import { render, staticRenderFns } from "./mineral.vue?vue&type=template&id=0bc6b980&scoped=true"
import script from "./mineral.vue?vue&type=script&lang=js"
export * from "./mineral.vue?vue&type=script&lang=js"
import style0 from "./mineral.vue?vue&type=style&index=0&id=0bc6b980&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0bc6b980",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/data/actions-runner/_work/treasurenet-tnservices-producerPlatform-fe/treasurenet-tnservices-producerPlatform-fe/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('0bc6b980')) {
      api.createRecord('0bc6b980', component.options)
    } else {
      api.reload('0bc6b980', component.options)
    }
    module.hot.accept("./mineral.vue?vue&type=template&id=0bc6b980&scoped=true", function () {
      api.rerender('0bc6b980', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/authentication/approve/components/mineral.vue"
export default component.exports